var _rect, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanvasNavZoom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 64,
    viewBox: "0 0 61 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.167969,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#9C64FF",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0356 17.9234C15.0356 16.2665 16.3788 14.9234 18.0356 14.9234H44.0356C45.6925 14.9234 47.0356 16.2665 47.0356 17.9234V32.9234C47.0356 34.5803 45.6925 35.9234 44.0356 35.9234H18.0356C16.3788 35.9234 15.0356 34.5803 15.0356 32.9234V17.9234Z",
    stroke: "#50307E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44986 25.2878L11.3996 20.3381M6.44986 25.2878L9.40685 25.1592M6.44986 25.2878L6.57842 22.3308",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3996 6.33731L20.4499 11.2871M25.3996 6.33731L22.4426 6.46588M25.3996 6.33731L25.2711 9.2943",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4145_3555)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_4145_3555",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7951 19.2169C33.3565 17.3672 35.3111 16.323 37.1608 16.8844C39.0104 17.4459 40.0547 19.4005 39.4932 21.2502L37.0148 29.415C39.0809 30.2786 41.1972 31.2927 42.4554 32.0464C44.5407 33.2956 46.7536 36.154 45.8201 39.2291L44.4502 43.7423C43.9364 45.4347 41.7704 50.9393 33.2528 48.3537C30.967 47.6598 29.4063 46.7841 28.3791 45.7657C28.3161 45.7135 28.2545 45.6589 28.1944 45.6016L18.7798 36.637C17.3799 35.304 17.3256 33.0886 18.6586 31.6887C19.9916 30.2889 22.207 30.2346 23.6069 31.5676L27.8265 35.5855C27.8331 35.5637 27.8398 35.5417 27.8464 35.5198L27.8571 35.4839L27.9891 35.0492L32.7951 19.2169Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7951 19.2169C33.3565 17.3672 35.3111 16.323 37.1608 16.8844C39.0104 17.4459 40.0547 19.4005 39.4932 21.2502L37.0148 29.415C39.0809 30.2786 41.1972 31.2927 42.4554 32.0464C44.5407 33.2956 46.7536 36.154 45.8201 39.2291L44.4502 43.7423C43.9364 45.4347 41.7704 50.9393 33.2528 48.3537C30.967 47.6598 29.4063 46.7841 28.3791 45.7657C28.3161 45.7135 28.2545 45.6589 28.1944 45.6016L18.7798 36.637C17.3799 35.304 17.3256 33.0886 18.6586 31.6887C19.9916 30.2889 22.207 30.2346 23.6069 31.5676L27.8265 35.5855C27.8331 35.5637 27.8398 35.5417 27.8464 35.5198L27.8571 35.4839L27.9891 35.0492L32.7951 19.2169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0148 29.415L35.101 28.8341L34.5761 30.5633L36.2435 31.2603L37.0148 29.415ZM42.4554 32.0464L43.4831 30.3307L42.4554 32.0464ZM45.8201 39.2291L43.9064 38.6482L43.9064 38.6482L45.8201 39.2291ZM44.4502 43.7423L46.364 44.3232L46.364 44.3232L44.4502 43.7423ZM28.3791 45.7657L29.7873 44.3454L29.7235 44.2822L29.6543 44.2249L28.3791 45.7657ZM28.1944 45.6016L26.8153 47.05L26.8153 47.05L28.1944 45.6016ZM18.7798 36.637L17.4006 38.0854L17.4006 38.0854L18.7798 36.637ZM18.6586 31.6887L20.107 33.0679L18.6586 31.6887ZM23.6069 31.5676L22.2277 33.016L23.6069 31.5676ZM27.8265 35.5855L26.4474 37.034L28.8017 39.2757L29.7412 36.1635L27.8265 35.5855ZM27.8464 35.5198L29.7609 36.0985L29.7632 36.0907L27.8464 35.5198ZM27.8571 35.4839L25.9433 34.903L25.9403 34.913L27.8571 35.4839ZM37.7417 14.9707C34.8351 14.0884 31.7636 15.7294 30.8813 18.636L34.7088 19.7978C34.9495 19.0051 35.7871 18.5576 36.5799 18.7982L37.7417 14.9707ZM41.407 21.8311C42.2893 18.9245 40.6483 15.853 37.7417 14.9707L36.5799 18.7982C37.3726 19.0388 37.8201 19.8765 37.5795 20.6692L41.407 21.8311ZM38.9285 29.9959L41.407 21.8311L37.5795 20.6692L35.101 28.8341L38.9285 29.9959ZM43.4831 30.3307C42.106 29.5058 39.8898 28.449 37.786 27.5697L36.2435 31.2603C38.2721 32.1082 40.2883 33.0797 41.4276 33.7622L43.4831 30.3307ZM47.7339 39.81C48.3929 37.639 47.9137 35.594 47.0182 33.9819C46.1363 32.3944 44.8015 31.1205 43.4831 30.3307L41.4276 33.7622C42.1945 34.2216 43.0088 35.0014 43.5214 35.9242C44.0203 36.8223 44.1808 37.7441 43.9064 38.6482L47.7339 39.81ZM46.364 44.3232L47.7339 39.81L43.9064 38.6482L42.5364 43.1613L46.364 44.3232ZM32.6719 50.2675C37.3922 51.7004 40.765 50.9842 43.06 49.2469C45.2386 47.5977 46.0667 45.3023 46.364 44.3232L42.5364 43.1613C42.3199 43.8747 41.8081 45.1777 40.6458 46.0576C39.6 46.8492 37.6309 47.5926 33.8337 46.4399L32.6719 50.2675ZM26.971 47.1859C28.3079 48.5114 30.2003 49.5172 32.6719 50.2675L33.8337 46.4399C31.7336 45.8024 30.5047 45.0567 29.7873 44.3454L26.971 47.1859ZM29.6543 44.2249C29.627 44.2023 29.6001 44.1784 29.5736 44.1532L26.8153 47.05C26.909 47.1393 27.0053 47.2248 27.104 47.3064L29.6543 44.2249ZM29.5736 44.1532L20.1589 35.1886L17.4006 38.0854L26.8153 47.05L29.5736 44.1532ZM20.1589 35.1886C19.559 34.6173 19.5357 33.6679 20.107 33.0679L17.2102 30.3096C15.1155 32.5094 15.2008 35.9908 17.4006 38.0854L20.1589 35.1886ZM20.107 33.0679C20.6783 32.468 21.6277 32.4447 22.2277 33.016L24.986 30.1192C22.7862 28.0245 19.3048 28.1098 17.2102 30.3096L20.107 33.0679ZM22.2277 33.016L26.4474 37.034L29.2057 34.1371L24.986 30.1192L22.2277 33.016ZM25.9319 34.9412C25.9252 34.9633 25.9186 34.9855 25.9119 35.0076L29.7412 36.1635C29.7477 36.1418 29.7543 36.1202 29.7609 36.0985L25.9319 34.9412ZM25.9403 34.913L25.9296 34.9489L29.7632 36.0907L29.7739 36.0548L25.9403 34.913ZM26.0753 34.4682L25.9433 34.903L29.7709 36.0649L29.9028 35.6301L26.0753 34.4682ZM30.8813 18.636L26.0753 34.4682L29.9028 35.6301L34.7088 19.7978L30.8813 18.636Z",
    fill: "#50307E",
    mask: "url(#path-5-inside-1_4145_3555)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4145_3555",
    x: 11.6934,
    y: 10.7326,
    width: 48.3467,
    height: 52.3008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.188235 0 0 0 0 0.494118 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3555",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanvasNavZoom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas_nav_zoom.67870c1faf5d4f285fe2d874f0117b43.svg";